import { render, staticRenderFns } from "./EventTicketListEmpty.vue?vue&type=template&id=64fc0a69&scoped=true&"
import script from "./EventTicketListEmpty.vue?vue&type=script&lang=js&"
export * from "./EventTicketListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./EventTicketListEmpty.vue?vue&type=style&index=0&id=64fc0a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc0a69",
  null
  
)

export default component.exports